<template>
  <div class="review-order">
    <div class="review-order__content container">
      <div class="section">
        <h1 class="title is-3 has-text-grey">
          {{ $t("orderDetails.orderSummary") }}
        </h1>
        <h2
          v-if="
            orderTrackingInfo &&
              orderTrackingInfo.orderStatus === 'ORDER_COMPLETED'
          "
          class="title is-4 has-text-grey"
        >
          {{ $t("orderDetails.hasBeenShipped") }}.
        </h2>
      </div>
      <div class="section main-cart">
        <CartItemList
          :is-editable="isEditable"
          :has-minimal-items="true"
          :cart-items="orderTrackingInfo.items || allCartItems"
        />
      </div>
      <!-- template v-if="!$route.params.orderId">
        <hr
          class="has-background-grey"
          v-if="paymentDetails.payment_method !== 'quote'"
        />
        <validate-voucher-form />
      </template -->
      <hr class="has-background-grey" />
      <div class="section">
        <CartSum />
      </div>
      <hr class="has-background-grey" />
      <div class="section">
        <ChooseShippingOption :is-editable="isEditable" />
      </div>
      <hr class="has-background-grey" />
      <div class="section">
        <CustomerSummary></CustomerSummary>
      </div>
      <hr class="has-background-grey" />
      <div class="section">
        <div class="columns">
          <OrderSummary class="column is-half-tablet"></OrderSummary>
        </div>
      </div>
      <div class="section">
        <OrderSum></OrderSum>
      </div>
      <div class="section">
        <label
          class="checkbox"
          :title="$route.params.orderId && 'Sie haben bereits zugestimmt'"
        >
          <input
            type="checkbox"
            v-model="agreeToTermsAndConditions"
            :disabled="!isEditable"
          />
          {{$t("checkout.condition1")}}
          <a
            href="https://maagtechnic.ch/content/dam/ch/pdf/unternehmen/rechtliches/Maagtechnic%20AGB_DE_0819.pdf"
            target="_blank"
            >{{$t("checkout.condition2")}}</a
          >
          {{$t("checkout.condition3")}}
        </label>
        <!--label class="checkbox">
          <input type="checkbox" v-model="agreeToNewsletter" />
          Ich möchte in Zukunft über Angebote und Neuigkeiten von Murtfeldt
          Additive Solutions benachrichtigt werden.
        </label-->
      </div>

      <div
        class="container has-text-right mb-5"
        v-if="
          shippingMethod && positionPrice / 100 <= 250
        "
      >
        <span class="has-text-primary-dark">{{$tc("discount.minimumOrderTotalNotReached",250 | toCents | currency)}}</span
        >
      </div>
      <div class="section has-text-right review-order__actions">
        <div class="secondary-actions">
          <RouterLink v-if="!$route.params.orderId" to="/cart" class="link"
            >{{$t('checkout.cart.editCart')}}
          </RouterLink>
          <RouterLink
            v-if="
              !(
                paymentDetails.billingPaymentMethod === 'paypal' &&
                $route.params.orderId
              )
            "
            :to="`/payment-details/${$route.params.orderId || ''}`"
            class="link"
            >{{$t('checkout.cart.actionLabels.editPaymentDetails')}}
          </RouterLink>
        </div>
        <button
          @click="createOrUpdateOrder()"
          v-if="shippingMethod"
          :title="
            !agreeToTermsAndConditions
              ? 'Bitte stimmen Sie den AGB zu'
              : 'Kostenpflichtig bestellen'
          "
          :disabled="!agreeToTermsAndConditions"
          :class="{ 'is-loading': orderIsProcessing }"
          class="button is-rounded is-primary-dark px-6"
        >
          {{ primaryButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CartItemList from "./CartItemList";
import CartSum from "./ReviewOrder/CartSum";
import CustomerSummary from "./ReviewOrder/CustomerSummary";
import ChooseShippingOption from "./ReviewOrder/ChooseShippingOption";
import OrderSummary from "./ReviewOrder/OrderSummary";
import OrderSum from "./ReviewOrder/OrderSum";
import { mapGetters } from "vuex";
import ValidateVoucherForm from "./discounts/ValidateVoucherForm";
import { sendGenericErrorMessage } from "../../utilities/send-generic-error-message";

export default {
  name: "ReviewOrder",
  components: {
    ValidateVoucherForm,
    OrderSum,
    OrderSummary,
    ChooseShippingOption,
    CustomerSummary,
    CartSum,
    CartItemList,
  },
  data() {
    return {
      agreeToTermsAndConditions: false,
      orderIsProcessing: false,
      discountCode: "",
      discountValidated: false,
      discountCodeIsValid: false,
      isEditable: true,
      shippingMethod: {
        shippingPriceCent: 1337,
      },
    };
  },
  computed: {
    ...mapGetters([
      "paymentDetails",
      "cartSum",
      "positionPrice",
      "taxRate",
      "allCartItems",
      "orderTrackingInfo",
    ]),
    primaryButtonText() {
      switch (this.paymentDetails.billingPaymentMethod) {
        case "paypal":
          return this.$i18n.t("checkout.finaliseOrder.goToPayPal");
        case "quote":
          return this.$i18n.t("checkout.finaliseOrder.getQuote");
        default:
          return this.$i18n.t("checkout.finaliseOrder.buyNow");
      }
    },
    agreeToNewsletter: {
      get() {
        return this.paymentDetails.signupToNewsletter;
      },
      set(value) {
        this.$store.dispatch("updatePaymentDetails", {
          paymentDetails: { signUpToNewsletter: value },
        });
      },
    },
  },

  methods: {
    async loadOrder() {
      if (!this.orderTrackingInfo._id) {
        try {
          await this.$store.dispatch("fetchOrderTrackingInfo", {
            orderId: this.$route.params.orderId,
          });
          this.agreeToTermsAndConditions = true;
        } catch (e) {
          sendGenericErrorMessage();
          return;
        }
      }
      this.isEditable = false;
    },

    async createOrUpdateOrder() {
      this.orderIsProcessing = true;
      if (this.$route.params.orderId) {
        await this.$store.dispatch("updateOrder");
        if (this.paymentDetails.billingPaymentMethod === "paypal") {
          this.$router.push("/redirecting");
        }
        return;
      } else {
        try {
          await this.$store.dispatch("createOrder");
          if (this.paymentDetails.billingPaymentMethod === "paypal") {
            this.$router.push("/redirecting");
          } else if (this.paymentDetails.billingPaymentMethod === "quote") {
            this.$router.push("/quote-generated");
          } else {
            this.$router.push("/order-complete");
          }
        } catch (e) {
          this.$router.push("/order-failed");
          sendGenericErrorMessage();
        }
      }
    },

    async generateQuote() {
      this.orderIsProcessing = true;
      await this.$store.dispatch("finaliseOrder");

      if (this.paymentDetails.payment_method === "paypal") {
        this.$router.push("/redirecting");
      } else {
        this.$router.push("/order-complete");
      }
    },

    fetchCMSData() {
      this.$store.dispatch("fetchCMSPage", { urlSlug: "/" });
    },
  },

  async created() {
    if (this.$route.params.orderId) {
      await this.loadOrder();
      this.agreeToTermsAndConditions = true;
    } else {
      this.$store.dispatch("resetOrderTrackingInfo");
    }
  },
  getMaagtechnicProductionTime() {
    const estimatedProductionTimesByWeekday = {
        0: 9, // Sunday
        1: 8, // Monday
        2: 7, //...
        3: 6,
        4: 5,
        5: 4,
        6: 9, //Saturday
    };

    return estimatedProductionTimesByWeekday[new Date().getDay()];
  },
};
</script>
